import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "./Navbar";
import {
  fetchVendorrecommendationsItems,
  updateVendorrecommendationsItems,
} from "./redux/slices/VendorrecommendationsThunks";

export default function Adminrecommendationsone() {
  const dispatch = useDispatch();
  const recommend = useSelector((state) => state.vendorrecommendations.items);
  const [showData, setShowData] = useState([]);
  const [archivedData, setArchivedData] = useState([]);
  const [allShowData, setAllShowData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [active, setActive] = useState();
  const [search, setSearch] = useState("");
  const [showArchived, setShowArchived] = useState(false);

  const handleClick = (item) => {
    setActive(item);
  };

  const editClick = async (item) => {
    var data = { ...item };
    data.is_archived = !item?.is_archived;
    await dispatch(updateVendorrecommendationsItems(data));
    await getRecommended();
  };

  useEffect(() => {
    if (allShowData.length > 0) {
      const lowerSearch = search.toLowerCase();
      const filtered = allShowData.filter((val) =>
        [val.email_address, val.company_name, val.phone_number]
          .filter(Boolean) // remove undefined/null
          .some((field) => field.toLowerCase().includes(lowerSearch))
      );

      if (showArchived) setArchivedData(filtered);
      else setShowData(filtered);
    }
  }, [search, recommend]);

  useEffect(() => {
    if (showArchived) setAllShowData(archivedData);
    else setAllShowData(showData);
  }, [showArchived]);

  useEffect(() => {
    if (recommend.length > 0) {
      const tableColumns = [
        { key: "email_address", width: "40%" },
        { key: "phone_number", width: "20%" },
        { key: "company_name", width: "25%" },
        { key: "recommend_action", width: "20%" },
      ];

      const archived = recommend.filter((item) => item?.is_archived == true);
      const unArchived = recommend.filter(
        (item) => item?.is_archived === false || !("is_archived" in item)
      );

      const tableData =
        unArchived.length > 0
          ? unArchived.map((val, idx) => {
              return {
                _id: val?._id,
                email_address: val.email_address ? val.email_address : "",
                phone_number: val.phone_number ? val.phone_number : "",
                first_name: val.first_name ? val.first_name : "",
                last_name: val.last_name ? val.last_name : "",
                company_name: val.company_name ? val.company_name : "",
                company_website: val.company_website ? val.company_website : "",
                reason_for_nomination: val.reason_for_nomination
                  ? val.reason_for_nomination
                  : "",
                is_archived: val?.is_archived ? val?.is_archived : false,
              };
            })
          : [];
      const tableArchivedData =
        archived.length > 0
          ? archived.map((val, idx) => {
              return {
                _id: val?._id,
                email_address: val.email_address ? val.email_address : "",
                phone_number: val.phone_number ? val.phone_number : "",
                first_name: val.first_name ? val.first_name : "",
                last_name: val.last_name ? val.last_name : "",
                company_name: val.company_name ? val.company_name : "",
                company_website: val.company_website ? val.company_website : "",
                reason_for_nomination: val.reason_for_nomination
                  ? val.reason_for_nomination
                  : "",
                is_archived: val?.is_archived ? val?.is_archived : false,
              };
            })
          : [];
      setTableColumn(tableColumns);
      setArchivedData(tableArchivedData);
      setShowData(tableData);
      setAllShowData(tableData);
    }
  }, [recommend]);

  const getRecommended = () => {
    try {
      dispatch(fetchVendorrecommendationsItems());
      const tableHeaders = [
        { label: "Email", width: "40%" },
        { label: "Phone", width: "20%" },
        { label: "Company", width: "25%" },
        { label: "Action", width: "20%" },
      ];
      setTableHeader(tableHeaders);
    } catch (e) {
      console.log(e, "error");
    }
  };

  useEffect(() => {
    getRecommended();
  }, []);

  return (
    <RootWrapperAdminrecommendationsone>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            {active ? (
              <>
                <DashboardHeader>
                  <Frame1462>
                    <LinkButton>
                      <BackContainer
                        onClick={() => {
                          setActive();
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.3334 8H2.66675"
                            stroke="#3B5A6F"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.66675 12L2.66675 8L6.66675 4"
                            stroke="#6162C5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <BackText>Back</BackText>
                      </BackContainer>
                    </LinkButton>
                    <WelcomeJames>{active?.email}</WelcomeJames>
                  </Frame1462>
                </DashboardHeader>
                <Frame1485>
                  <Frame1468>
                    <Frame1473>
                      <Frame1470>
                        <Frame1477>
                          <FirstName>First Name</FirstName>
                          <James>{active?.first_name}</James>
                        </Frame1477>
                      </Frame1470>
                      <Frame1470>
                        <Frame1477>
                          <LastName>Last Name</LastName>
                          <Doe>{active?.last_name}</Doe>
                        </Frame1477>
                      </Frame1470>
                    </Frame1473>
                    <Frame1477>
                      <Phone>Phone</Phone>
                      <_4412345678901>{active?.phone_number}</_4412345678901>
                    </Frame1477>
                    <Frame1477>
                      <EmailAddress>Email Address</EmailAddress>
                      <NewvendorEmailCom>
                        {active?.email_address}
                      </NewvendorEmailCom>
                    </Frame1477>
                    <Frame1477>
                      <CompanyNameOfTheVendor>
                        Company Name of the Vendor
                      </CompanyNameOfTheVendor>
                      <Nesti>{active?.company_name}</Nesti>
                    </Frame1477>
                    <Frame1477>
                      <VendorSWebsite>Vendor’s Website</VendorSWebsite>
                      <WwwNestiCom>{active?.company_website}</WwwNestiCom>
                    </Frame1477>
                    <Frame1477>
                      <ReasonForYourNomination>
                        Reason for your nomination
                      </ReasonForYourNomination>
                      <LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                        {active?.reason_for_nomination}
                      </LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry>
                    </Frame1477>
                  </Frame1468>
                </Frame1485>
              </>
            ) : (
              <>
                <DashboardHeader>
                  <Frame1462>
                    <WelcomeJames>Vendor Recommendations</WelcomeJames>
                  </Frame1462>
                  <Frame1461>
                    <AIMEButton
                      size="small"
                      onClick={() => {
                        setShowArchived(!showArchived);
                      }}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "row",
                        alignItems: "center",
                        flex: "none",
                        gap: "10px",
                        borderRadius: "48px",
                        background: "rgba(97, 98, 197, 1)",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        boxSizing: "border-box",
                        padding: "16px 32px",
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          textOverflow: "ellipsis",
                          fontSize: "16px",
                          fontFamily: "Montserrat, sans-serif",
                          fontWeight: "600",
                          lineHeight: "110%",
                          textAlign: "left",
                        }}
                      >
                        {showArchived ? "Show unarchived" : "Show archived"}
                      </span>
                    </AIMEButton>
                  </Frame1461>
                </DashboardHeader>
                <ContentBox>
                  <TableTitle>
                    <Frame1431>
                      <Frame1431_0001>
                        <Title>
                          {showArchived ? "Archived" : "New"} Recommendations
                        </Title>
                      </Frame1431_0001>
                    </Frame1431>
                    <Frame1432>
                      <GFieldsStacked>
                        <GFieldsStacked_0001>
                          <PRTNR.Input
                            type="text"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </GFieldsStacked_0001>
                      </GFieldsStacked>
                    </Frame1432>
                  </TableTitle>
                  <PRTNR.TableComponent
                    data={showArchived ? archivedData : showData}
                    tableColumn={tableColumn}
                    tableHeader={tableHeader}
                    viewClick={handleClick}
                    editClick={editClick}
                    showArchived={showArchived}
                  />
                </ContentBox>
              </>
            )}
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>
    </RootWrapperAdminrecommendationsone>
  );
}

const RootWrapperAdminrecommendationsone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;
const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 12px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
`;

const Frame1431_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 557px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;


const LinkButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1485 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1468 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Frame1473 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1470 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 415px;
  box-sizing: border-box;
`;

const Frame1477 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const FirstName = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const James = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const LastName = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Doe = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Phone = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const _4412345678901 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const EmailAddress = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const NewvendorEmailCom = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const CompanyNameOfTheVendor = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Nesti = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const VendorSWebsite = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const WwwNestiCom = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const ReasonForYourNomination = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const LoremIpsumIsSimplyDummyTextOfThePrintingAndTypesettingIndustry = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const BackText = styled.span`
  color: #64748b;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: left;
`;
